import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalesTargetReportService {

  constructor(private http: HttpClient) { }

  ur1 = environment.serverAPI9 + "/api/salesTargetReport";



  searchSalesTargetReport(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: string,type: number): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}&type=${type}`;

    return this.http.post<Response[]>(`${this.ur1}/condition/${queryParams}`, requestBody);
  }

    searchSalesTargetReportFilter(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: string): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };
    let type=4;
    const queryParams = `?page=${page}&size=${size}&sort=${sort}&type=${type}`;

    return this.http.post<Response[]>(`${this.ur1}/condition/${queryParams}`, requestBody);
  }

}
